//React
import { FunctionComponent, useEffect, useState } from "react";

//API
import { searchApi } from "../../redux/api/search-api";
import { searchQmiApi } from "../../redux/api/search-qmi-api";

//Actions
import { setInitialMapSettingsStateFromUrl } from "../../../map/redux/slices/map-settings-slice";
import { setInitialFacetStateFromUrl } from "../../../facets/redux/slices/facet-slice";
import { setInitialQmiFinderStateFromUrl } from "../../redux/slices/app-status-slice";


//Selectors
import { selectMapSettings } from "../../../map/redux/selectors/select-map-settings";
import { selectIsQmiFinder } from "../../redux/selectors/select-is-qmi-finder";
import { selectIsAppLoaded } from "../../redux/selectors/select-app-loaded";

//App Hooks
import {
	useAppDispatch,
	useAppSelector,
} from "../../redux/hooks/redux-store-hooks";

//Util
import { setAppLoaded } from "../../redux/slices/app-status-slice";

//Components
import { UrlManagerLocation } from "../../../map/components/url/url-manager-location";
import { UrlManagerAreaInfo } from "../../../area-info/components/url/url-manager-area-info";
import { UrlManagerFacets } from "../../../facets/components/url/url-manager-facets";
import { UrlManagerHotw } from "./url-manager-hotw";

/** A top level component that kicks off searching and contains things
 *  like the components that adjust the URL */
const AppManager: FunctionComponent = () => {
	let dispatch = useAppDispatch();

	//We do not want to query until some initial values are set, otherwise we get an empty query
	const [skipQuery, setSkipQuery] = useState(true);
	const [skipQmiQuery, setSkipQmiQuery] = useState(true);

	//Use Effects
	useEffect(() => {

		//Set the initial map settings from the URL
		dispatch(setInitialMapSettingsStateFromUrl(window.location.href));

		//Set the initial facet settings from the URL
		dispatch(setInitialFacetStateFromUrl(window.location.href));
        
		//Set the isQMIFinder bool from the url
		dispatch(setInitialQmiFinderStateFromUrl(window.location.href));

		//Set app loaded to true
		dispatch(setAppLoaded(true));

	}, []);


	//Call the API whenever the map settings change
	const mapSettings = useAppSelector(selectMapSettings);


	//If app has loaded, set whether to query the default Comms API or the QMI API
	const isAppLoaded = useAppSelector(selectIsAppLoaded);
	const isQmiFinder = useAppSelector(selectIsQmiFinder);

	useEffect(() => {

		if (!isAppLoaded) {
			return;
		}

		if (isQmiFinder) {
			setSkipQmiQuery(false);
			setSkipQuery(true);
		} else {
			setSkipQuery(false);
			setSkipQmiQuery(true);
		}

	}, [isAppLoaded, isQmiFinder]);

	//Search Results API Query
	searchApi.useGetApiResultsQuery(
		{
			path: mapSettings.path,
			mapSettings: mapSettings.locationZoomSettings,
		},
		{ skip: skipQuery, refetchOnMountOrArgChange: true },
	);

	//Search QMI Results API Query
	searchQmiApi.useGetQmiApiResultsQuery(
		{
			path: mapSettings.path,
			mapSettings: mapSettings.locationZoomSettings,
		},
		{ skip: skipQmiQuery, refetchOnMountOrArgChange: true },
	);

	return (
		<>
			<UrlManagerLocation />
			<UrlManagerAreaInfo />
			<UrlManagerFacets />
			<UrlManagerHotw />
		</>
	);
};

export default AppManager;
